import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  data: {},
  log: {},
  conn: {},
  clientList: [],
  mqttClient: null,
  connState: null,
  wsClientID: null,
  configQueue: [],
  alarmState: [],
  updatedList: [],
  downloadTopic: null,
  mqttLoading: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
